import { http } from '../../../../api/http';
import type { ListaPrecio } from '../types/listaPrecio.types';

export class ListaPrecioService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/lista-precio',
  };

  public static async getAll(): Promise<ListaPrecio[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching listas de precio:', error);
      throw error;
    }
  }

  public static async getById(id: number): Promise<ListaPrecio> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lista de precio:', error);
      throw error;
    }
  }

  public static async save(data: ListaPrecio): Promise<ListaPrecio> {
    try {
      const response = await http.post(this.ENDPOINTS.BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error saving lista de precio:', error);
      throw error;
    }
  }

  public static async update(id: number, data: ListaPrecio): Promise<ListaPrecio> {
    try {
      const response = await http.put(`${this.ENDPOINTS.BASE}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating lista de precio:', error);
      throw error;
    }
  }

  public static async delete(id: number): Promise<boolean> {
    try {
      await http.delete(`${this.ENDPOINTS.BASE}/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting lista de precio:', error);
      throw error;
    }
  }

  public static async getPrecioArticulo(idListaPrecio: number, idArticulo: number): Promise<number | null> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/precio/${idListaPrecio}/${idArticulo}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching precio articulo:', error);
      return null;
    }
  }
}
